import {cs}                             from "@Common/react/chain-services";
import {scopedState}                    from "@Common/react/scoped-state";
import {UseState}                       from "@Common/react/use-state";
import {getNestedValue, setNestedValue} from "@Common/utils/arr-path";
import {chain}                          from "@Common/utils/fs";

import {setCurrentToSaved} from "./set-current-to-saved";

export const DeliveryMethodLogic = ({templateOptions, item, next: rootNext}) => cs(
    ["state", (_, next) => UseState({
        getInitValue: () => chain(
            getNestedValue(item, ["selections", "distributionType"]) ??
            chain(
                templateOptions.distributions,
                (_) => _.find((d) => d === templateOptions.defaultDeliveryMethod) ?? _[0],
            ),
            (_) => ({
                saved  : _,
                current: _,
            })
        ),
        _key: templateOptions.sku.back ?? templateOptions.sku.front,
        next,
    })],

    ({state}) => rootNext({

        itemEditor: {
            $name: "delivery method",
            valid: true,
            changed: state.value.saved !== state.value.current,
            prepareSave: (item) => ({
                newValue: setNestedValue(item, ["selections", "distributionType"], state.value.current),
                onSaved: () => setCurrentToSaved(state),
            }),
        },

        method: state.value.current,

        ui: scopedState(state, ["current"]),
    }),
);
